import { useRef, useEffect } from 'react';

const TriggerValidation = ({ formMethods }) => {
    const isMounted = useRef(false);
    const { watch, trigger } = formMethods;
    const [checkboxes0, checkboxes1, checkboxes2] = watch([
        'checkboxes.0',
        'checkboxes.1',
        'checkboxes.2',
    ]);
    useEffect(() => {
        // avoid validation when component just mounted
        if (!isMounted.current) {
            isMounted.current = true;
            return;
        }
        // dynamically validate
        trigger(['checkboxes.0', 'checkboxes.1', 'checkboxes.2']);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [checkboxes0, checkboxes1, checkboxes2]);
    return null;
};

export { TriggerValidation as T };
//# sourceMappingURL=TriggerValidation-EwWymetQ.js.map
